import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'


export const missalSchema = new schema.Entity(
    'missals',
    {},
    {
        idAttribute: 'idname',
    }
)

export const missal_getPageById_Api = {
    backend: `Route::get('missals/{id}/page/{page_nbr}/get', 'MissalController@getPageById');`,
    root: API_ROOT_URL,
    path: '/missals/:id/page/:page_nbr/get',
    method: 'GET',
    schema: missalSchema,
    transform: createTransform(missalSchema, 'data'),
}
export const missal_getById_Api = {
    backend: `Route::get('missals/{id}/get', 'MissalController@getById');`,
    root: API_ROOT_URL,
    path: '/missals/:id/get',
    method: 'GET',
    schema: missalSchema,
    transform: createTransform(missalSchema, 'data'),
}
export const missal_getItems_Api = {
    backend: `Route::get('missals/get-items', 'MissalController@getItems');`,
    root: API_ROOT_URL,
    path: '/missals/get-items',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword', 'language', 'is_static', 'hashtags', 'missal_type', 'exclude_missal_type'],
    schema: missalSchema,
    transform: createListTransform(missalSchema),
}
export const missal_create_Api = {
    backend: `Route::post('missal/create', 'MissalController@create');`,
    root: API_ROOT_URL,
    path: '/missals/create',
    method: 'POST',
    paramsFields: [],
    schema: missalSchema,
    transform: createTransform(missalSchema, 'data'),
}
export const missal_update_Api = {
    backend: `Route::post('missals/{id}/edit', 'MissalController@update');`,
    root: API_ROOT_URL,
    path: '/missals/:id/edit',
    method: 'POST',
    paramsFields: [],
    schema: missalSchema,
    transform: createTransform(missalSchema, 'data'),
}
export const missal_updateOnPage_Api = {
    backend: `Route::post('missals/{id}/page/{page_nbr}/edit', 'MissalController@updateOnPage');`,
    root: API_ROOT_URL,
    path: '/missals/:id/page/:page_nbr/edit',
    method: 'POST',
    paramsFields: [],
    schema: missalSchema,
    transform: createTransform(missalSchema, 'data'),
}
export const missal_copyTo_Api = {
    backend: `Route::post('missals/{id}/copy-to', 'MissalController@copyTo');`,
    root: API_ROOT_URL,
    path: '/missals/:id/copy-to',
    method: 'POST',
    paramsFields: [],
    schema: missalSchema,
    transform: createTransform(missalSchema, 'data'),
}
export const missal_delete_Api = {
    backend: `Route::post('missals/{id}/delete', 'MissalController@delete');`,
    root: API_ROOT_URL,
    path: '/missals/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: missalSchema,
    transform: createTransform(missalSchema, 'data'),
}


export const missalVersionSchema = new schema.Entity(
    'missal_versions',
    {},
    {
        idAttribute: 'id',
    }
)
export const missal_getVersionById_Api = {
    backend: `Route::get('missals/version/{id}/get', 'MissalController@getVersionById');`,
    root: API_ROOT_URL,
    path: '/missals/version/:id/get',
    method: 'GET',
    schema: missalVersionSchema,
    transform: createTransform(missalVersionSchema, 'data'),
}
export const missal_getMissalVersionItems_Api = {
    backend: `Route::get('missals/{type}/{id}/get-items', 'MissalController@getMissalVersionItems');`,
    root: API_ROOT_URL,
    path: '/missals/:type/:id/get-items',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword'],
    schema: missalVersionSchema,
    transform: createListTransform(missalVersionSchema),
}
export const missal_saveAs_Api = {
    backend: `Route::post('missals/{id}/version/save-as', 'MissalController@saveAs');`,
    root: API_ROOT_URL,
    path: '/missals/:id/version/save-as',
    method: 'POST',
    paramsFields: [],
    schema: missalVersionSchema,
    transform: createTransform(missalVersionSchema, 'data'),
}
export const missal_editMissalVersion_Api = {
    backend: `Route::post('missals/version/{id}/edit', 'MissalController@editMissalVersion');`,
    root: API_ROOT_URL,
    path: '/missals/version/:id/edit',
    method: 'POST',
    paramsFields: [],
    schema: missalVersionSchema,
    transform: createTransform(missalVersionSchema, 'data'),
}
export const missal_deleteMissalVersion_Api = {
    backend: `Route::post('missals/version/{id}/delete', 'MissalController@deleteMissalVersion');`,
    root: API_ROOT_URL,
    path: '/missals/version/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: missalVersionSchema,
    transform: createTransform(missalVersionSchema, 'data'),
}